<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { useShare } from '../../etc/hooks/useShare';

  import {
    type IBusinessSocialReward,
    SocialRewardsTypeEnum
  } from '../../services/social-rewards';
  import Button from '../form/Button.svelte';
  import Check from '../icons/Check.svelte';

  import FacebookLike from '../icons/SocialRewards/FacebookLike.svelte';
  import FacebookShare from '../icons/SocialRewards/FacebookShare.svelte';
  import InstagramFollow from '../icons/SocialRewards/InstagramFollow.svelte';
  import PinterestFollow from '../icons/SocialRewards/PinterestFollow.svelte';
  import TikTokFollow from '../icons/SocialRewards/TikTokFollow.svelte';
  import TwitterFollow from '../icons/SocialRewards/TwitterFollow.svelte';
  import TwitterShare from '../icons/SocialRewards/TwitterShare.svelte';
  import YoutubeSubscribe from '../icons/SocialRewards/YoutubeSubscribe.svelte';

  import Label from '../typography/Label.svelte';
  import Text from '../typography/Text.svelte';

  export let item: IBusinessSocialReward;

  export let onClick: (shareUrl?: string) => void;

  const t = (text: string) => {
    return $_(`social_rewards.${text}`);
  };

  const { getUrlFacebook, getUrlTwitter } = useShare();

  $: alreadyClaimed = Number(item.redeemed || '0') > 0;

  const socialItem: any = {
    [SocialRewardsTypeEnum.FACEBOOK_SHARE]: {
      iconComponent: FacebookShare,
      title: t(`${SocialRewardsTypeEnum.FACEBOOK_SHARE}.title`),
      btn: t(`${SocialRewardsTypeEnum.FACEBOOK_SHARE}.btn`),
      share: () => getUrlFacebook(item.metadata.url)
    },
    [SocialRewardsTypeEnum.FACEBOOK_LIKE]: {
      iconComponent: FacebookLike,
      title: t(`${SocialRewardsTypeEnum.FACEBOOK_LIKE}.title`),
      btn: t(`${SocialRewardsTypeEnum.FACEBOOK_LIKE}.btn`)
    },
    [SocialRewardsTypeEnum.INSTAGRAM_FOLLOW]: {
      iconComponent: InstagramFollow,
      title: t(`${SocialRewardsTypeEnum.INSTAGRAM_FOLLOW}.title`),
      btn: t(`${SocialRewardsTypeEnum.INSTAGRAM_FOLLOW}.btn`)
    },
    [SocialRewardsTypeEnum.TWITTER_FOLLOW]: {
      iconComponent: TwitterFollow,
      title: t(`${SocialRewardsTypeEnum.TWITTER_FOLLOW}.title`),
      btn: t(`${SocialRewardsTypeEnum.TWITTER_FOLLOW}.btn`)
    },
    [SocialRewardsTypeEnum.TWITTER_SHARE]: {
      iconComponent: TwitterShare,
      title: t(`${SocialRewardsTypeEnum.TWITTER_SHARE}.title`),
      btn: t(`${SocialRewardsTypeEnum.TWITTER_SHARE}.btn`),
      share: () =>
        getUrlTwitter({ text: item.metadata.message, url: item.metadata.url })
    },
    [SocialRewardsTypeEnum.YOUTUBE_SUBSCRIBE]: {
      iconComponent: YoutubeSubscribe,
      title: t(`${SocialRewardsTypeEnum.YOUTUBE_SUBSCRIBE}.title`),
      btn: t(`${SocialRewardsTypeEnum.YOUTUBE_SUBSCRIBE}.btn`)
    },
    [SocialRewardsTypeEnum.TIKTOK_FOLLOW]: {
      iconComponent: TikTokFollow,
      title: t(`${SocialRewardsTypeEnum.TIKTOK_FOLLOW}.title`),
      btn: t(`${SocialRewardsTypeEnum.TIKTOK_FOLLOW}.btn`)
    },
    [SocialRewardsTypeEnum.PINTEREST_FOLLOW]: {
      iconComponent: PinterestFollow,
      title: t(`${SocialRewardsTypeEnum.PINTEREST_FOLLOW}.title`),
      btn: t(`${SocialRewardsTypeEnum.PINTEREST_FOLLOW}.btn`)
    }
  };

  const onClickButton = () => {
    const { share } = socialItem[item.type];

    onClick(share ? share() : '');
  };
</script>

<div class="twism-social-item {alreadyClaimed ? '--claimed' : ''}">
  <svelte:component this={socialItem[item.type].iconComponent} />
  <div class="twism-social-item__content">
    <Label class="twism-social-item__content-title" type="default-semibold">
      {socialItem[item.type].title}
    </Label>
    <Label type="default-regular">{item.coinsClaimed || item.coins} coins</Label
    >
  </div>
  <Button
    class="twism-social-item__btn"
    loading={item.loading}
    on:click={onClickButton}
  >
    {#if alreadyClaimed}
      <Check stroke="#fff" />
    {:else}
      <Text class="twism-text-button" type="default"
        >{socialItem[item.type].btn}</Text
      >
    {/if}
  </Button>
</div>

<style lang="scss">
  :global(.twism-social-item__btn) {
    height: 32px !important;
    width: 72px !important;
    padding: 4px 10px !important;
    border-radius: 8px !important;
  }

  :global(.twism-social-item__btn p) {
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: -0.01em !important;
  }

  :global(.twism-social-item__content-title) {
    margin-bottom: 4px !important;
    letter-spacing: -0.01em !important;
  }

  .twism-social-item {
    display: flex;
    align-items: center;
    padding: 0px 0px 20px;
    border-bottom: 1px solid rgba(1, 42, 90, 0.1);
    margin-top: 16px;

    &.--claimed {
      opacity: 0.6;
      pointer-events: none;
    }

    &__content {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin: 0 12px;
    }
  }
</style>
